import { render, staticRenderFns } from "./PendingJobs.vue?vue&type=template&id=c0d6f2f0"
import script from "./PendingJobs.vue?vue&type=script&lang=js"
export * from "./PendingJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports